
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';


export const salesService = {
  getSalesOrderList,
  salesOrderDetails,
  setSalesOrderBulkAction,
  getEntrySalesOrderData,
  submitSalesOrder,
  getSalesOrderInvoiceList,
  getSalesOrderListByDate,
  getSalesOrderSearch,
  salesOrderShippingOrder,
  submitSalesOrderAddress,
  getSalesOrderReturnList,
  salesOrderReturnDetails,
  getSalesOrderReturnSearch,
  getSalesOrderReturnListByDate,
  salesOrderReturnAction,
  updateSalesReturnItems
};

async function  getSalesOrderList() {
    return  apiClient.get(`/sales/sales-order-list`, authHeader());
}



async function  getSalesOrderListByDate(body) {
    return  apiClient.put(`/sales/sales-order-list-by-date`, body, authHeader());
}


async function  getSalesOrderSearch(searchText) {
    return  apiClient.get(`/sales/sales-order-list-search?search=${searchText}`, authHeader());
}

async function  salesOrderDetails(salesOrderId) {
    return  apiClient.get(`/sales/sales-order-details/${salesOrderId}`, authHeader());
}


async function  salesOrderShippingOrder(salesOrderId) {
    return apiClient.get(`/sales/sales-order-shipping-data/${salesOrderId}`, authHeader());
}

async function  setSalesOrderBulkAction(body) {
    return  apiClient.patch(`/sales/set-sales-order-action`, body, authHeader());
}

async function  getEntrySalesOrderData() {
    return  apiClient.get(`/sales/get-sales-entry-data`, authHeader());
}

async function  submitSalesOrder(body) {
    return  apiClient.post(`/sales/submit-sales-order`,body, authHeader());
}


async function  submitSalesOrderAddress(body) {
    return  apiClient.patch(`/sales/submit-sales-order-address`,body, authHeader());
}

async function  getSalesOrderInvoiceList() {
    return  apiClient.get(`/sales/sales-order-entry-invoice-list`, authHeader());
}


// ============= SALES ORDER RETURN ============
async function getSalesOrderReturnList() {
    return apiClient.get(`/sales/sales-order-return-list`, authHeader());
}

async function salesOrderReturnDetails(salesOrderId) {
    return apiClient.get(`/sales/sales-order-return-details/${salesOrderId}`, authHeader());
}


async function getSalesOrderReturnSearch(searchText) {
  return apiClient.get(`/sales/sales-order-return-search?search=${searchText}`, authHeader());
}


async function getSalesOrderReturnListByDate(body) {
  return apiClient.put(`/sales/sales-order-return-by-date`, body, authHeader());
}



async function salesOrderReturnAction(body) {
  return apiClient.put(`/sales/sales-order-return-action`, body, authHeader());
}


async function updateSalesReturnItems(body) {
  return apiClient.patch(`/sales/sales-order-update-items`, body, authHeader());
}


// ============= SALES ORDER RETURN END============



















